import { Stack, Title } from "@mantine/core"

import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"
import { contentVerticalSpacingCSSVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { useGetTranslationsContext } from "../context/translationsContext/useGetTranslationsContext"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

export const GenericTitle = () => {
  const { t } = useGetTranslationsContext()

  return (
    <Stack
      key={`generic-passport-title-block`}
      gap={DesignStudioParametersToolkit.getCssVariableLiteralName(
        contentVerticalSpacingCSSVariable
      )}
    >
      <Title
        order={3}
        className={CommunicationStudioClasses.GENERIC_PASSPORT_TITLE}
      >
        {t("title")}
      </Title>
    </Stack>
  )
}
